import { PermissionEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { CircularProgress, Sidebar } from '@hyperflake/react-ui-library';
import useClientInstallationData from 'modules/client-installation/hooks/useClientInstallationData';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

const InstallationSidebar = () => {
    const { clientInstallationId } = useParams();
    const { clientInstallation, isLoading, setData } = useClientInstallationData(clientInstallationId);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const { hasPermission } = useAuthPermission();

    const navItems = [
        // {
        //     content: 'Project',
        //     href: '/project-installation',
        //     isActive: pathname.startsWith('/project-installation'),
        //     permission: hasPermission(PermissionEnum.PROJECT_INSTALLATION_READ),
        // },
        {
            content: `${clientInstallation?.name}`,
            href: `/client-installations/${clientInstallationId}/details`,
            isActive: pathname.startsWith(`/client-installations/${clientInstallationId}/details`),
            permission: hasPermission(PermissionEnum.CLIENT_INSTALLATION_READ),
        },
        {
            content: 'Projects',
            href: `/client-installations/${clientInstallationId}/project-installations`,
            isActive: pathname.startsWith(`/client-installations/${clientInstallationId}/project-installations`),
            permission: hasPermission(PermissionEnum.PROJECT_INSTALLATION_READ),
        },
    ];
    return (
        <Sidebar className="border-r-0 md:border-r ">
            <Sidebar.Nav>
                <>
                    <Link
                        to={`/client-installations`}
                        // to=""
                        // /clients/10212/projects/21091/cctv-cameras/98673426/edit-cctv
                    >
                        <div className="p-4">{`<-  Back`}</div>
                    </Link>

                    {isLoading ? (
                        <CircularProgress size={20} />
                    ) : (
                        navItems.map(
                            (row, i) =>
                                row.permission && (
                                    <Sidebar.NavItem key={i} isActive={row.isActive} onClick={() => navigate(row.href)}>
                                        <Link to={row.href}>{row.content}</Link>
                                    </Sidebar.NavItem>
                                )
                        )
                    )}
                </>
            </Sidebar.Nav>
        </Sidebar>
    );
};

export default InstallationSidebar;
